import React from 'react';
import PricingOpportunityFieldWorkOfficeItem from '../../../Domain/PricingOpportunityFieldWorkOfficeItem';
import PricingOpportunityOwningOfficeItem from '../../../Domain/PricingOpportunityOwningOfficeItem';
import TabbedPage from '../../../Elements/TabbedPage';
import PricingAdmin from './PricingAdmin';
import PricingServiceFieldWorkOfficeItem from '../../../Domain/PricingServiceFieldWorkOfficeItem';
import PricingServiceOwningOfficeItem from '../../../Domain/PricingServiceOwningOfficeItem';

class PricingMain extends React.Component {
  state = {};

  Opportunitytabs = [
    {
      label: 'Fieldwork Office',
      id: 'FieldworkOffice',
      icon: 'fa-solid fa-regular fa-building-circle-arrow-right',
      component: (
        <PricingAdmin
          Type={PricingOpportunityFieldWorkOfficeItem}
          TypeName='PricingOpportunityFieldWorkOfficeItem'
          PricingSearchParams={{ OpportunityId: `${this.props.OpportunityId}`, type: '1' }}
          OpportunityStatusCode={this.props.OpportunityStatusCode}
          Navigation={true}
        />
      ),
    },
    {
      label: 'Owning Office',
      id: 'OwningOffice',
      icon: 'fa-solid fa-server',
      component: (
        <PricingAdmin
          Type={PricingOpportunityOwningOfficeItem}
          TypeName='PricingOpportunityOwningOfficeItem'
          PricingSearchParams={{ OpportunityId: `${this.props.OpportunityId}`, type: '2' }}
          OpportunityStatusCode={this.props.OpportunityStatusCode}
          Navigation={true}
        />
      ),
    },
    {
      label: 'Replaced Pricings',
      id: 'Replaced Pricings',
      icon: 'fa-solid fa-server',
      component: (
        <PricingAdmin
          Type={PricingOpportunityOwningOfficeItem}
          PricingSearchParams={{
            OpportunityId: this.props.OpportunityId,
            StatusCode: '7',
            type: '3',
          }}
          Navigation={true}
          OpportunityStatusCode={this.props.OpportunityStatusCode}
        />
      ),
    },
  ];

  ServiceTabs = [
    {
      label: 'Fieldwork Office',
      id: 'FieldworkOffice',
      icon: 'fa-solid fa-regular fa-building-circle-arrow-right',
      component: (
        <PricingAdmin
          Type={PricingServiceFieldWorkOfficeItem}
          TypeName='PricingOpportunityFieldWorkOfficeItem'
          PricingSearchParams={{ ServiceId: `${this.props.ServiceId}` }}
          OpportunityStatusCode={this.props.OpportunityStatusCode}
          Navigation={true}
        />
      ),
    },
    {
      label: 'Owning Office',
      id: 'OwningOffice',
      icon: 'fa-solid fa-server',
      component: (
        <PricingAdmin
          Type={PricingServiceOwningOfficeItem}
          TypeName='PricingOpportunityOwningOfficeItem'
          PricingSearchParams={{ ServiceId: `${this.props.ServiceId}` }}
          OpportunityStatusCode={this.props.OpportunityStatusCode}
          Navigation={true}
        />
      ),
    },
    {
      label: 'Replaced Pricings',
      id: 'Replaced Pricings',
      icon: 'fa-solid fa-server',
      component: (
        <PricingAdmin
          Type={PricingServiceOwningOfficeItem}
          PricingSearchParams={{
            ServiceId: `${this.props.ServiceId}`,
            StatusCode: '7',
          }}
          Navigation={true}
          OpportunityStatusCode={this.props.OpportunityStatusCode}
        />
      ),
    },
  ];

  render() {
    return (
      <div className='TabbedPage'>
        <TabbedPage
          tabs={this.props.OpportunityId !== undefined ? this.Opportunitytabs : this.ServiceTabs}
          className='border rounded opacity70'
        />
      </div>
    );
  }
}

export default PricingMain;
